<div class="hc-section-heading" [class.hc-section-heading--small]="variant === 'small'" [class.hc-section-heading--tiny]="variant === 'tiny'">
  <div class="hc-section-heading__badge">
    <ng-content select="[sectionIcon]"></ng-content>
  </div>
  <div class="hc-section-heading__content">
    <h5 class="hc-section-heading__title">
      <ng-content></ng-content>
    </h5>
    @if (variant === 'small' && metadata) {
      <div class="hc-section-heading__divider"></div>
      <span class="hc-section-heading__metadata">{{ metadata }}</span>
    }
  </div>
</div>
